// FE-only suppression reasons. BE-defined reasons flow through the
// `tripInsuranceSuppressionReasons` prop from BuildReservationFlowProps —
// keep this file for values the FE emits without a BE round-trip.
export const SuppressionReasons = {
  // Emitted when the quote fetch itself rejects (network/parse failure).
  LOAD_FAILURE: "load_failure",
}
